// extracted by mini-css-extract-plugin
export default {"root":"styles_root__dWsLV","container":"styles_container__qMb7Q","text":"styles_text__Tf--e","image":"styles_image__HZkKQ"};